import React from 'react'
import './Content.scss'

import wireRodTopPic from '../../assets/Pictures/WireRodTop.jpg'
import wireRodTable from '../../assets/Pictures/wireRodTable.jpg'
import wireRodTable2 from '../../assets/Pictures/wireRodTable2.jpg'

import steelRebarTopPic from '../../assets/Pictures/SteelRebarTop.png'
import steelRebarTable from '../../assets/Pictures/SteelRebarTable.jpg'
import steelRebarTable2 from '../../assets/Pictures/SteelRebarTable2.svg'

import standardgalvanizedTopPic from '../../assets/Pictures/StandardGalvanizedTop.png'
import standardgalvanizedTable from '../../assets/Pictures/StandardGalvanizedTable.svg'

import steelIngotTopPic from '../../assets/Pictures/SteelIngotTop.png'
import steelIngotTable from '../../assets/Pictures/SteelIngotTable.svg'
import steelIngotTable2 from '../../assets/Pictures/SteelIngotTable2.svg'

import EPIndustrialCoolerTop from '../../assets/Pictures/EPIndustrialCoolerTop.jpg'
import EPIndustrialCooler1 from '../../assets/Pictures/EPIndustrialCooler1.jpg'
import EPIndustrialCooler2 from '../../assets/Pictures/EPIndustrialCooler2.jpg'
import EPIndustrialCooler3 from '../../assets/Pictures/EPIndustrialCooler3.jpg'

export default function Content({ page }) {
  return (
    <div className='contentPage'>
      <div className="container">
        <div className="row">
          {page === 'wireRod' ? <img className='pageTop' src={wireRodTopPic} alt='wireRodTopPic' /> : ''}
          {page === 'wireRod' ? <img className='pageTable' src={wireRodTable} alt='wireRodTopPic' /> : ''}
          {page === 'wireRod' ? <img className='pageTable2' src={wireRodTable2} alt='wireRodTable2' /> : ''}

          {page === 'steelRebar' ? <img className='pageTop' src={steelRebarTopPic} alt='steelRebarTopPic' /> : ''}
          {page === 'steelRebar' ? <img className='pageTable' src={steelRebarTable} alt='steelRebarTable' /> : ''}
          {page === 'steelRebar' ? <img className='pageTable2' src={steelRebarTable2} alt='steelRebarTable2' /> : ''}

          {page === 'standardgalvanized' ? <img className='pageTop' src={standardgalvanizedTopPic} alt='standardgalvanizedTopPic' /> : ''}
          {page === 'standardgalvanized' ? <img className='standardgalvanizedTable' src={standardgalvanizedTable} alt='standardgalvanizedTable' /> : ''}

          {page === 'steelIngot' ? <img className='pageTop' src={steelIngotTopPic} alt='steelIngotTopPic' /> : ''}
          {page === 'steelIngot' ? <img className='pageTable' src={steelIngotTable} alt='steelIngotTable' /> : ''}
          {page === 'steelIngot' ? <img className='pageTable2' src={steelIngotTable2} alt='steelIngotTable2' /> : ''}

          {page === 'EPIndustrialCooler' ? <img className='pageTop' src={EPIndustrialCoolerTop} alt='steelIngotTopPic' /> : ''}
          {page === 'EPIndustrialCooler' ? <img className='pageTable' src={EPIndustrialCooler1} alt='steelIngotTable' /> : ''}
          {page === 'EPIndustrialCooler' ? <img className='pageTable' src={EPIndustrialCooler2} alt='steelIngotTable' /> : ''}
          {page === 'EPIndustrialCooler' ? <img className='pageTable' src={EPIndustrialCooler3} alt='steelIngotTable' /> : ''}
        </div>
      </div>
    </div>
  )
}
